/* eslint-disable import/prefer-default-export */
import {
  calculateBomTotals,
  hasValidSelectedPartSupplier,
  hasValidPartSupplierSelections,
} from 'pcb-parts/utils/helpers';
import {
  ARROW_CODE,
  VERICAL_CODE,
} from 'pcb-parts/utils/extracters';

const calculateMarkups = (totals) => {
  const markups = {};
  Object.keys(totals).forEach((board_qty) => {
    let markup = 0.2;
    if (totals[board_qty] >= 25000) markup = 0.18;
    markups[board_qty] = markup;
  });
  return markups;
};

const calculateShipping = (bom_line_items, board_qtys) => {
  const shipping = {};
  const shipping_price = 30;
  const found_suppliers = {};
  board_qtys.forEach((board_qty) => {
    found_suppliers[board_qty] = [];
  });
  bom_line_items
    .filter((bli) => bli.user_action === 'buy')
    .forEach((bli) => {
      board_qtys.forEach((board_qty) => {
        if (hasValidPartSupplierSelections(bli.selected_part, board_qty)) {
          bli.selected_part.ps_selections[board_qty].forEach((ps) => {
            const s_code =
              ps.supplier.code === VERICAL_CODE ? ARROW_CODE : ps.supplier.code;
            if (!found_suppliers[board_qty].includes(s_code))
              found_suppliers[board_qty].push(s_code);
          });
        }

        if (hasValidSelectedPartSupplier(bli.selected_part, board_qty)) {
          const ps = bli.selected_part.selected_part_supplier[board_qty];
          const s_code =
            ps.supplier.code === VERICAL_CODE ? ARROW_CODE : ps.supplier.code;
          if (!found_suppliers[board_qty].includes(s_code))
            found_suppliers[board_qty].push(s_code);
        }
      });
    });
  Object.keys(found_suppliers).forEach((board_qty) => {
    shipping[board_qty] = found_suppliers[board_qty].length * shipping_price;
  });

  return shipping;
};

export const calculateBomPrices = (state) => {
  const base_totals = calculateBomTotals(
    state.bom_line_items,
    state.board_qtys,
  );
  const markups = calculateMarkups(base_totals);
  const shipping = calculateShipping(state.bom_line_items, state.board_qtys);

  state.base_totals = base_totals;
  state.markups = markups;
  state.shipping = shipping;

  state.board_qtys.forEach((board_qty) => {
    state.totals[board_qty] =
      base_totals[board_qty] * (1 + markups[board_qty]) + shipping[board_qty];
  });
};
